import React, { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const Acordeon = ({ 
  title, 
  content, 
  isSelected = false, 
  isSelectedWhithoutcolor = false, 
  isExternalActive = false,
  // Nuevas props para comportamiento de acordeón
  accordionId = null,
  activeAccordionId = null,
  onAccordionToggle = null
}) => {
  const [isActive, setIsActive] = useState(false);
  
  // Aplicar siempre la clase del título
  const titleClassName = 'titulo_subEspecialidad_acordion';

  // Determinar si este acordeón está activo
  const isAccordionActive = accordionId !== null 
    ? activeAccordionId === accordionId 
    : isActive;

  const handleToggle = () => {
    if (accordionId !== null && onAccordionToggle) {
      // Comportamiento de acordeón: si está abierto, lo cierra; si está cerrado, lo abre
      onAccordionToggle(isAccordionActive ? null : accordionId);
    } else {
      // Comportamiento original: toggle interno
      setIsActive(!isActive);
    }
  };

  const InternalAction = () => {
    return (
      <div
        className={`accordion-item ${
          isAccordionActive && content[0] ? "accordion-item-open" : ""
        } ${isSelected && "activeTab"}`}
      >
        <div
          className={`accordion-title ${
            content[0] ? "" : "accordion-title-empty"
          }`}
          onClick={() => content && handleToggle()}
        >
          <div className={titleClassName}>{title}</div>
          {content[0] && (
            <div>
              {isAccordionActive ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
            </div>
          )}
        </div>
        
        {isAccordionActive && content[0]
          ? content.map(({ nombre }, index) => {
              return (
                <div
                  key={index}
                  className={`accordion-content ${
                    isAccordionActive ? "accordion-open" : ""
                  }`}
                  style={{ 
                    marginTop: index === 0 ? "15px" : "0",
                    wordWrap: "break-word",
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    lineHeight: "1.4"
                  }}
                >
                  {nombre}
                </div>
              );
            })
          : null}
      </div>
    );
  }

  const ExternalAction = () => {
    return (
      <div
        className={`accordion-item ${
          isExternalActive && isSelectedWhithoutcolor && content[0] ? "accordion-item-open" : ""
        } `}
      >
        <div
          className={`accordion-title ${
            content[0] ? "" : "accordion-title-empty"
          }`}
          // onClick={() => content && setIsActive(!isActive)}
        >
          <div className={titleClassName}>{title}</div>
          {content[0] && (
            <div>
              {isExternalActive && isSelectedWhithoutcolor ? <FiChevronUp size={20} /> : <FiChevronDown size={20} />}
            </div>
          )}
        </div>
        
        {isExternalActive && isSelectedWhithoutcolor && content[0]
          ? content.map(({ nombre }, index) => {
              return (
                <div
                  className={`accordion-content ${
                    isActive ? "accordion-open" : ""
                  }`}
                  style={{ marginTop: index === 0 ? "15px" : "0" }}
                >
                  {nombre}
                </div>
              );
            })
          : null}
      </div>
    );
  }

  return isExternalActive ? <ExternalAction/> : <InternalAction/>
};

export default Acordeon;
